module.exports = __webpack_public_path__ + "static/img/20190221021550_514524.1960a3ad.jpg";